import { render } from "./ItemSlot.vue?vue&type=template&id=a36d0e3e&scoped=true"
import script from "./ItemSlot.vue?vue&type=script&lang=ts"
export * from "./ItemSlot.vue?vue&type=script&lang=ts"

import "./ItemSlot.vue?vue&type=style&index=0&id=a36d0e3e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a36d0e3e"

export default script